import React from 'react';
import './GardenTherapy.css';
import { gardenTherapyData, images } from '../../../constants'; // Upewnij się, że masz import images
import { Heading, PageTitle } from '../../../components'; // Używamy Twojego komponentu Heading

const GardenTherapy = () => {
  return (
    <div className="garden-page-wrapper">
      
      <PageTitle title={gardenTherapyData.title} subTitle={gardenTherapyData.subtitle} />


      {/* 2. WSTĘP (Intro) - Styl sekcji "About" */}
      <section className="garden-intro section">
        <div className="garden-container">
            <div className="garden-row">
                <div className="garden-intro-text">
                    <Heading title="Natura, która leczy" sub="O metodzie" />
                    <p className="intro-desc">
                        {gardenTherapyData.intro.description}
                    </p>
                </div>
                {/* Opcjonalnie zdjęcie obok tekstu */}
                <div className="garden-intro-image">
                    <img src={images.gardenTheraphy_1} alt="Ogrodoterapia w praktyce" />
                </div>
            </div>
        </div>
      </section>

      {/* 3. KORZYŚCI (Benefits) - Styl sekcji "Features" lub "Counter" */}
      <section className="garden-benefits section">
          <Heading title="Korzyści Ogrodoterapii" sub="Naukowo potwierdzone" />
          
          <div className="garden-grid-4">
              {gardenTherapyData.benefits.map((item) => (
                  <div key={item.id} className="benefit-box">
                      <div className="benefit-icon-wrapper">
                          {/* Możesz tu użyć ikon z biblioteki, np. FontAwesome lub SVG */}
                          <span className="benefit-number">0{item.id}</span>
                      </div>
                      <h3>{item.title}</h3>
                      <p>{item.text}</p>
                      {item.source && <span className="benefit-source">{item.source}</span>}
                  </div>
              ))}
          </div>
      </section>

      {/* 4. NASZE PODEJŚCIE (Approach) - Styl sekcji "Services" */}
      <section className="garden-approach section">
          <Heading title="Nasze Podejście" sub="W Fundacji Dwór Imielno" />
          
          <div className="garden-grid-3">
              {gardenTherapyData.approach.map((item) => (
                  <div key={item.id} className="approach-card">
                      <div className="approach-image">
                          {/* Placeholder na zdjęcia tematyczne */}
                          <img src={item.images} alt={item.title} />
                      </div>
                      <div className="approach-content">
                          <h3>{item.title}</h3>
                          <p>{item.description}</p>
                      </div>
                  </div>
              ))}
          </div>
      </section>

      {/* 5. WIEDZA I INSPIRACJA (Zamiast Footera) */}
      <section className="garden-knowledge section">
          <div className="garden-knowledge-container">
              
              {/* Lewa kolumna: Cytat (Wyróżniona karta) */}
              <div className="knowledge-quote-wrapper">
                  <div className="quote-card">
                      <span className="quote-mark">“</span>
                      <p className="quote-text">{gardenTherapyData.footerQuote}</p>
                      <div className="quote-author">Fundacja Dwór Imielno</div>
                  </div>
              </div>

              {/* Prawa kolumna: Bibliografia (Lista) */}
              <div className="knowledge-biblio-wrapper">
                  <Heading title="Źródła Naukowe" sub="Publikacje i badania" />
                  
                  <ul className="biblio-list">
                      {gardenTherapyData.bibliography.map((item, index) => (
                          <li key={index} className="biblio-item">
                              <span className="biblio-icon">📖</span>
                              <span className="biblio-text">{item}</span>
                          </li>
                      ))}
                  </ul>
              </div>

          </div>
      </section>

    </div>
  );
}

export default GardenTherapy;